export default {
    mpanel: {
        submit: 'submit',
        cancel: 'cancel',
        mpage: {
            total: 'data',
            page: 'page'
        },
        mtable: {
            index: 'index',
            actions: 'actions'
        }
    },
    tagsNav: {
        allTags: 'All tags',
        closeAll: 'Close all'
    },
    tagsView: {
        refresh: 'Refresh',
        close: 'Close',
        closeOthers: 'Close Others',
        closeAll: 'Close all'
    },
    topHeader: {
        lang: 'EN',
        message: 'Message',
        service: 'Service And Support'
    }
};
